import React, { useEffect, useState, useRef } from 'react';
import { SendIcon, SearchIcon, XIcon, PlusIcon, MoreVerticalIcon, ArrowLeftIcon, PaperclipIcon, UserIcon, MessageSquareIcon, InfoIcon, BellIcon, CheckIcon, CalendarIcon, FileTextIcon, ClockIcon, DownloadIcon, Trash2Icon, AlertTriangleIcon, X, Check, Search } from 'lucide-react';
// Aynı interface'ler - değişmez
interface Message {
  id: string;
  sender: 'student' | 'teacher' | 'system';
  content: string;
  timestamp: string;
  type?: 'text' | 'image' | 'file' | 'notification';
  attachments?: {
    id: string;
    name: string;
    type: 'image' | 'document' | 'video';
    url: string;
    size?: string;
  }[];
  read?: boolean;
}
interface Conversation {
  id: string;
  type: 'direct' | 'group' | 'support' | 'program' | 'notification';
  title: string;
  preview: string;
  status?: 'waiting' | 'processing' | 'completed';
  date: string;
  unread: boolean;
  recipient: {
    id: string;
    name: string;
    role?: string;
    avatar?: string;
  };
  messages: Message[];
}
// Yeni Mesaj Modal Komponenti - Veli Paneli İçin
function VeliNewMessageModal({
  onClose,
  onCreateConversation
}) {
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  const [message, setMessage] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  // Veli için alıcı listesi
  const recipients = [{
    id: 'teacher-math',
    name: 'Ayşe Öğretmen',
    role: 'Matematik Öğretmeni',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&q=80',
    category: 'Öğretmen'
  }, {
    id: 'teacher-turkish',
    name: 'Mehmet Öğretmen',
    role: 'Türkçe Öğretmeni',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&q=80',
    category: 'Öğretmen'
  }, {
    id: 'teacher-class',
    name: 'Fatma Öğretmen',
    role: 'Sınıf Öğretmeni',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&q=80',
    category: 'Öğretmen'
  }, {
    id: 'management',
    name: 'Kurum Yönetimi',
    role: 'Okul Müdürü',
    avatar: null,
    category: 'Yönetim'
  }, {
    id: 'guidance',
    name: 'Rehberlik Servisi',
    role: 'Akademik Danışman',
    avatar: null,
    category: 'Rehberlik'
  }, {
    id: 'support',
    name: 'EĞİTİM PİLOTU DESTEK',
    role: 'Teknik Destek',
    avatar: null,
    category: 'Destek'
  }];
  // Arama filtreleme
  const filteredRecipients = recipients.filter(recipient => recipient.name.toLowerCase().includes(searchQuery.toLowerCase()) || recipient.role.toLowerCase().includes(searchQuery.toLowerCase()) || recipient.category.toLowerCase().includes(searchQuery.toLowerCase()));
  // Mesaj oluşturma
  const handleCreateConversation = () => {
    if (selectedRecipient && message.trim()) {
      onCreateConversation(selectedRecipient, message);
      onClose();
    }
  };
  // Kategori ikonu getir
  const getCategoryIcon = category => {
    switch (category) {
      case 'Öğretmen':
        return '🧑‍🏫';
      case 'Yönetim':
        return '👨‍💼';
      case 'Rehberlik':
        return '🧑‍⚕️';
      case 'Destek':
        return '🛠️';
      default:
        return '👤';
    }
  };
  return <div className="fixed inset-0 bg-black/90 flex items-center justify-center p-4 z-50" data-id="element-747">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600 shadow-[0_0_20px_rgba(59,130,246,0.4)] w-full max-w-xl" data-id="element-748">
        <div className="relative bg-black rounded-xl" data-id="element-749">
          {/* Header */}
          <div className="p-4 border-b border-blue-900/30 flex justify-between items-center" data-id="element-750">
            <h2 className="text-xl font-bold" data-id="element-751">Yeni Mesaj</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors" data-id="element-752">
              <X className="w-6 h-6" data-id="element-753" />
            </button>
          </div>
          {/* İçerik */}
          <div className="p-6 space-y-4" data-id="element-754">
            {/* Alıcı Arama */}
            <div className="space-y-2" data-id="element-755">
              <label className="text-sm font-medium text-gray-300" data-id="element-756">Alıcı</label>
              <div className="relative" data-id="element-757">
                <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Öğretmen, yönetim veya destek ara..." className="w-full bg-black border border-blue-900/30 text-white rounded-lg pl-10 pr-4 py-3 focus:outline-none focus:ring-1 focus:ring-blue-500/50" data-id="element-758" />
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-759" />
              </div>
            </div>
            {/* Alıcı Listesi */}
            <div className="space-y-2 max-h-[200px] overflow-y-auto" data-id="element-760">
              {filteredRecipients.map(recipient => <div key={recipient.id} onClick={() => setSelectedRecipient(recipient)} className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors ${selectedRecipient?.id === recipient.id ? 'bg-gradient-to-r from-blue-900/40 to-indigo-900/40 border border-blue-500/30' : 'hover:bg-blue-900/20 border border-transparent'}`} data-id="element-761">
                  {/* Avatar */}
                  {recipient.avatar ? <img src={recipient.avatar} alt={recipient.name} className="w-10 h-10 rounded-full object-cover" data-id="element-762" /> : <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 flex items-center justify-center text-lg" data-id="element-763">
                      {getCategoryIcon(recipient.category)}
                    </div>}
                  {/* Bilgiler */}
                  <div className="flex-1" data-id="element-764">
                    <h3 className="font-medium" data-id="element-765">{recipient.name}</h3>
                    <p className="text-sm text-gray-400" data-id="element-766">{recipient.role}</p>
                    <span className="text-xs px-2 py-0.5 bg-blue-900/30 text-blue-400 rounded-full" data-id="element-767">
                      {recipient.category}
                    </span>
                  </div>
                  {/* Seçim İşareti */}
                  {selectedRecipient?.id === recipient.id && <Check className="ml-auto w-5 h-5 text-blue-400" data-id="element-768" />}
                </div>)}
              {filteredRecipients.length === 0 && <div className="text-center py-4 text-gray-400" data-id="element-769">
                  Aranan kişi bulunamadı
                </div>}
            </div>
            {/* Mesaj Yazma Alanı */}
            <div className="space-y-2" data-id="element-770">
              <label className="text-sm font-medium text-gray-300" data-id="element-771">Mesaj</label>
              <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="Mesajınızı yazın..." className="w-full bg-black border border-blue-900/30 text-white rounded-lg px-4 py-3 min-h-[100px] resize-none focus:outline-none focus:ring-1 focus:ring-blue-500/50" data-id="element-772" />
            </div>
            {/* Seçili alıcı için öneriler */}
            {selectedRecipient && <div className="p-3 bg-blue-900/10 border border-blue-900/30 rounded-lg" data-id="element-773">
                <h4 className="text-sm font-medium text-blue-400 mb-2" data-id="element-774">
                  {selectedRecipient.name} ile iletişim önerileri:
                </h4>
                <div className="text-xs text-gray-400 space-y-1" data-id="element-775">
                  {selectedRecipient.category === 'Öğretmen' && <>
                      <p data-id="element-776">
                        • Çocuğunuzun akademik durumu hakkında soru
                        sorabilirsiniz
                      </p>
                      <p data-id="element-777">• Ev ödevi ve çalışma önerileri alabilirsiniz</p>
                    </>}
                  {selectedRecipient.category === 'Yönetim' && <>
                      <p data-id="element-778">• Okul politikaları hakkında bilgi alabilirsiniz</p>
                      <p data-id="element-779">• Genel şikayetlerinizi iletebilirsiniz</p>
                    </>}
                  {selectedRecipient.category === 'Rehberlik' && <>
                      <p data-id="element-780">• Çocuğunuzun gelişimi hakkında danışabilirsiniz</p>
                      <p data-id="element-781">• Çalışma programı talep edebilirsiniz</p>
                    </>}
                  {selectedRecipient.category === 'Destek' && <>
                      <p data-id="element-782">• Uygulama sorunları bildirebilirsiniz</p>
                      <p data-id="element-783">• Teknik yardım talep edebilirsiniz</p>
                    </>}
                </div>
              </div>}
          </div>
          {/* Footer Butonları */}
          <div className="p-4 border-t border-blue-900/30 flex justify-end gap-3" data-id="element-784">
            <button onClick={onClose} className="px-4 py-2 bg-transparent border border-blue-900/30 hover:bg-blue-900/10 text-gray-300 rounded-lg transition-colors" data-id="element-785">
              İptal
            </button>
            <button onClick={handleCreateConversation} disabled={!selectedRecipient || !message.trim()} className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:opacity-90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-786">
              Mesaj Gönder
            </button>
          </div>
        </div>
      </div>
    </div>;
}
// SADECE RENK DEĞİŞİKLİĞİ: MOR → LACİVERT
function VeliMessages() {
  const [activeConversationId, setActiveConversationId] = useState<string | null>(null);
  const [conversations, setConversations] = useState<Conversation[]>([{
    id: '1',
    type: 'direct',
    title: 'Ayşe Öğretmen',
    preview: 'Çocuğunuzun matematik performansı hakkında konuşmak istiyorum.',
    date: 'Bugün',
    unread: true,
    recipient: {
      id: 'teacher-1',
      name: 'Ayşe Öğretmen',
      role: 'Matematik Öğretmeni',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&q=80'
    },
    messages: [{
      id: 'm1',
      sender: 'teacher',
      content: 'Merhaba, çocuğunuzun matematik dersindeki gelişimi hakkında konuşmak istiyorum.',
      timestamp: 'Bugün, 09:30'
    }]
  }, {
    id: '2',
    type: 'support',
    title: 'Rehberlik Servisi',
    preview: 'Çocuğunuzun çalışma programı hazırlandı.',
    date: 'Dün',
    unread: false,
    recipient: {
      id: 'guidance',
      name: 'Rehberlik Servisi',
      role: 'Akademik Danışman'
    },
    messages: [{
      id: 'm1',
      sender: 'teacher',
      content: 'Çocuğunuz için kişisel çalışma programı hazırladık. İnceleyip geri dönüş yapabilir misiniz?',
      timestamp: 'Dün, 14:30'
    }]
  }]);
  const [message, setMessage] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [attachments, setAttachments] = useState<File[]>([]);
  const [showNewMessageModal, setShowNewMessageModal] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  // Dosya boyutu formatı için fonksiyon
  const formatFileSize = (bytes: number) => {
    if (bytes < 1024) return bytes + ' B';else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';else return (bytes / 1048576).toFixed(1) + ' MB';
  };
  // Dosya kaldırma fonksiyonu
  const removeAttachment = (index: number) => {
    const newAttachments = [...attachments];
    newAttachments.splice(index, 1);
    setAttachments(newAttachments);
  };
  // Konuşmaları filtrele
  const filteredConversations = conversations.filter(conversation => conversation.title.toLowerCase().includes(searchQuery.toLowerCase()) || conversation.recipient.name.toLowerCase().includes(searchQuery.toLowerCase()) || conversation.preview.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleFileSelect = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const fileArray = Array.from(e.target.files);
      setAttachments([...attachments, ...fileArray]);
    }
  };
  // Mesaj gönderme fonksiyonu
  const handleSendMessage = () => {
    if (activeConversationId && (message.trim() || attachments.length > 0)) {
      const newMessage: Message = {
        id: `m${Date.now()}`,
        sender: 'student',
        content: message.trim(),
        timestamp: `Bugün, ${new Date().getHours().toString().padStart(2, '0')}:${new Date().getMinutes().toString().padStart(2, '0')}`,
        attachments: attachments.length > 0 ? attachments.map(file => ({
          id: `att-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`,
          name: file.name,
          type: file.type.startsWith('image/') ? 'image' : 'document',
          url: URL.createObjectURL(file),
          size: formatFileSize(file.size)
        })) : undefined
      };
      // Konuşmayı güncelle
      setConversations(prev => prev.map(conv => {
        if (conv.id === activeConversationId) {
          return {
            ...conv,
            messages: [...conv.messages, newMessage],
            preview: message.trim() || `${attachments.length} dosya gönderdi`,
            date: 'Şimdi'
          };
        }
        return conv;
      }));
      // Inputları temizle
      setMessage('');
      setAttachments([]);
    }
  };
  // Enter ile gönderme
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };
  // Yeni konuşma oluşturma fonksiyonu
  const handleCreateConversation = (recipient, messageText) => {
    // Mevcut konuşma var mı kontrol et
    const existingConversation = conversations.find(conv => conv.recipient.id === recipient.id);
    if (existingConversation) {
      // Mevcut konuşmaya mesaj ekle
      const newMessage = {
        id: `m${Date.now()}`,
        sender: 'student',
        content: messageText,
        timestamp: `Bugün, ${new Date().getHours().toString().padStart(2, '0')}:${new Date().getMinutes().toString().padStart(2, '0')}`
      };
      setConversations(prev => prev.map(conv => {
        if (conv.id === existingConversation.id) {
          return {
            ...conv,
            messages: [...conv.messages, newMessage],
            preview: messageText.substring(0, 50) + (messageText.length > 50 ? '...' : ''),
            date: 'Şimdi',
            unread: false
          };
        }
        return conv;
      }));
      setActiveConversationId(existingConversation.id);
    } else {
      // Yeni konuşma oluştur
      const newConversation = {
        id: Date.now().toString(),
        type: 'direct',
        title: recipient.name,
        preview: messageText.substring(0, 50) + (messageText.length > 50 ? '...' : ''),
        date: 'Şimdi',
        unread: false,
        recipient: recipient,
        messages: [{
          id: 'm1',
          sender: 'student',
          content: messageText,
          timestamp: `Bugün, ${new Date().getHours().toString().padStart(2, '0')}:${new Date().getMinutes().toString().padStart(2, '0')}`
        }]
      };
      setConversations(prev => [newConversation, ...prev]);
      setActiveConversationId(newConversation.id);
    }
  };
  // Aktif konuşmayı bul
  const activeConversation = conversations.find(c => c.id === activeConversationId);
  return <div className="h-[calc(100vh-200px)] min-h-[500px] flex gap-6 bg-black" data-id="element-787">
      {/* Sol Panel - Konuşma Listesi */}
      <div className="w-full md:w-80 flex flex-col relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600 shadow-[0_0_15px_rgba(59,130,246,0.3)]" data-id="element-788">
        {' '}
        {/* LACİVERT */}
        <div className="flex-1 flex flex-col bg-black rounded-xl overflow-hidden" data-id="element-789">
          <div className="p-4 border-b border-blue-900/30" data-id="element-790">
            {' '}
            {/* LACİVERT */}
            <div className="flex justify-between items-center mb-4" data-id="element-791">
              <h2 className="text-xl font-bold" data-id="element-792">Mesajlar</h2>
              <button onClick={() => setShowNewMessageModal(true)} className="p-2 rounded-full bg-black hover:bg-blue-900/20 text-gray-400 hover:text-white transition-colors border border-blue-900/50" data-id="element-793">
                {' '}
                {/* LACİVERT */}
                <PlusIcon className="w-5 h-5" data-id="element-794" />
              </button>
            </div>
            <div className="relative" data-id="element-795">
              <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Mesaj ara..." className="w-full bg-black border border-blue-900/30 text-white rounded-lg pl-10 pr-4 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500/50" /* LACİVERT */ data-id="element-796" />
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-797" />
              {searchQuery && <button onClick={() => setSearchQuery('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white" data-id="element-798">
                  <XIcon className="w-4 h-4" data-id="element-799" />
                </button>}
            </div>
          </div>
          {/* Konuşma listesi */}
          <div className="flex-1 overflow-y-auto p-2 space-y-1" data-id="element-800">
            {filteredConversations.length > 0 ? filteredConversations.map(conversation => <div key={conversation.id} className={`p-3 rounded-lg cursor-pointer transition-colors ${activeConversationId === conversation.id ? 'bg-gradient-to-r from-blue-900/40 to-indigo-900/40 border border-blue-500/30' /* LACİVERT */ : 'hover:bg-blue-900/20 border border-transparent' /* LACİVERT */}`} onClick={() => setActiveConversationId(conversation.id)} data-id="element-801">
                  <div className="flex items-center gap-3" data-id="element-802">
                    <div className="relative" data-id="element-803">
                      {conversation.recipient.avatar ? <img src={conversation.recipient.avatar} alt={conversation.recipient.name} className="w-10 h-10 rounded-full object-cover" data-id="element-804" /> : <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 flex items-center justify-center" data-id="element-805">
                          {' '}
                          {/* LACİVERT */}
                          <UserIcon className="w-5 h-5" data-id="element-806" />
                        </div>}
                      {conversation.unread && <div className="absolute -left-1 top-0 w-3 h-3 bg-blue-500 rounded-full shadow-[0_0_5px_rgba(59,130,246,0.7)]" data-id="element-807" /> /* LACİVERT */}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-808">
                      <div className="flex justify-between items-center" data-id="element-809">
                        <h3 className={`text-sm truncate ${conversation.unread ? 'font-bold' : 'font-medium'}`} data-id="element-810">
                          {conversation.title}
                        </h3>
                        <span className="text-xs text-gray-400 whitespace-nowrap ml-2" data-id="element-811">
                          {conversation.date}
                        </span>
                      </div>
                      <p className={`text-xs text-gray-400 truncate ${conversation.unread ? 'font-bold' : 'font-normal'}`} data-id="element-812">
                        {conversation.preview}
                      </p>
                    </div>
                  </div>
                </div>) : <div className="text-center py-8 text-gray-400" data-id="element-813">
                {searchQuery ? `"${searchQuery}" için sonuç bulunamadı` : 'Henüz mesaj yok'}
              </div>}
          </div>
        </div>
      </div>
      {/* Sağ Panel - Aktif Konuşma */}
      <div className="flex-1 flex flex-col relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-600 shadow-[0_0_15px_rgba(59,130,246,0.3)]" data-id="element-814">
        {' '}
        {/* LACİVERT */}
        <div className="flex-1 flex flex-col bg-black rounded-xl overflow-hidden" data-id="element-815">
          {activeConversationId && activeConversation ? <>
              {/* Mesaj alanı header */}
              <div className="p-4 border-b border-blue-900/30" data-id="element-816">
                {' '}
                {/* LACİVERT */}
                <h2 className="text-xl font-bold" data-id="element-817">
                  {activeConversation.title}
                </h2>
                <p className="text-sm text-gray-400" data-id="element-818">
                  {activeConversation.recipient.role}
                </p>
              </div>
              {/* Mesajlar */}
              <div className="flex-1 overflow-y-auto p-4" data-id="element-819">
                {activeConversation.messages.map(message => <div key={message.id} className={`flex ${message.sender === 'student' ? 'justify-end' : 'justify-start'} mb-4`} data-id="element-820">
                    <div className={`relative max-w-[80%] ${message.sender === 'student' ? 'bg-gradient-to-r from-blue-600 to-indigo-600 rounded-l-lg rounded-tr-lg' /* LACİVERT */ : 'bg-black border border-blue-900/30 rounded-r-lg rounded-tl-lg' /* LACİVERT */} px-4 py-3`} data-id="element-821">
                      {/* Mesaj metni */}
                      {message.content && <p className="text-sm" data-id="element-822">{message.content}</p>}
                      {/* Eklenen dosyalar */}
                      {message.attachments && message.attachments.length > 0 && <div className="mt-2 space-y-2" data-id="element-823">
                            {message.attachments.map(attachment => {
                    if (attachment.type === 'image') {
                      return <div key={attachment.id} className="rounded-lg overflow-hidden" data-id="element-824">
                                    <img src={attachment.url} alt={attachment.name} className="w-full h-auto max-h-[200px] object-cover" data-id="element-825" />
                                  </div>;
                    } else {
                      return <div key={attachment.id} className="flex items-center gap-2 p-2 bg-black/30 rounded-lg border border-blue-900/30" data-id="element-826">
                                    <FileTextIcon className="w-5 h-5 text-blue-400" data-id="element-827" />
                                    <div className="flex-1 min-w-0" data-id="element-828">
                                      <p className="text-xs font-medium truncate" data-id="element-829">
                                        {attachment.name}
                                      </p>
                                      {attachment.size && <p className="text-xs text-gray-400" data-id="element-830">
                                          {attachment.size}
                                        </p>}
                                    </div>
                                    <button className="p-1 hover:bg-white/10 rounded-full text-gray-400 hover:text-white transition-colors" data-id="element-831">
                                      <DownloadIcon className="w-4 h-4" data-id="element-832" />
                                    </button>
                                  </div>;
                    }
                  })}
                          </div>}
                      {/* Zaman damgası */}
                      <div className={`text-xs mt-1 ${message.sender === 'student' ? 'text-white/70' : 'text-gray-400'}`} data-id="element-833">
                        {message.timestamp}
                      </div>
                    </div>
                  </div>)}
              </div>
              {/* Mesaj yazma alanı */}
              <div className="border-t border-blue-900/30 p-4" data-id="element-834">
                {' '}
                {/* LACİVERT */}
                <div className="relative" data-id="element-835">
                  {/* Seçilen dosyaların önizlemesi */}
                  {attachments.length > 0 && <div className="mb-3 flex flex-wrap gap-2" data-id="element-836">
                      {attachments.map((file, index) => <div key={index} className="flex items-center gap-2 bg-blue-900/20 text-white rounded-lg px-3 py-1.5 text-sm" data-id="element-837">
                          <span className="truncate max-w-[150px]" data-id="element-838">
                            {file.name}
                          </span>
                          <button onClick={() => removeAttachment(index)} className="text-gray-400 hover:text-white" data-id="element-839">
                            <XIcon className="w-4 h-4" data-id="element-840" />
                          </button>
                        </div>)}
                    </div>}
                  <textarea value={message} onChange={e => setMessage(e.target.value)} onKeyDown={handleKeyDown} placeholder="Mesajınızı yazın..." className="w-full bg-black text-white border border-blue-900/30 rounded-lg pl-4 pr-24 py-3 min-h-[80px] resize-none focus:outline-none focus:ring-1 focus:ring-blue-500/50" /* LACİVERT */ data-id="element-841" />
                  <div className="absolute bottom-3 right-3 flex items-center gap-2" data-id="element-842">
                    <input type="file" ref={fileInputRef} onChange={handleFileChange} className="hidden" multiple data-id="element-843" />
                    <button onClick={handleFileSelect} className="p-2 rounded-full bg-black hover:bg-blue-900/20 text-gray-400 hover:text-white transition-colors border border-blue-900/50" data-id="element-844">
                      <PaperclipIcon className="w-5 h-5" data-id="element-845" />
                    </button>
                    <button onClick={handleSendMessage} disabled={!message.trim() && attachments.length === 0 || !activeConversationId} className="p-2 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:opacity-90 transition-colors disabled:opacity-50" data-id="element-846">
                      {' '}
                      {/* LACİVERT */}
                      <SendIcon className="w-5 h-5" data-id="element-847" />
                    </button>
                  </div>
                </div>
              </div>
            </> : <div className="flex-1 flex flex-col items-center justify-center p-8 text-center" data-id="element-848">
              <div className="w-16 h-16 rounded-full bg-blue-900/20 flex items-center justify-center mb-4" data-id="element-849">
                {' '}
                {/* LACİVERT */}
                <MessageSquareIcon className="w-8 h-8 text-blue-400" data-id="element-850" />{' '}
                {/* LACİVERT */}
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-851">
                Mesajlarınız burada görünecek
              </h3>
              <p className="text-gray-400 mb-6 max-w-md" data-id="element-852">
                Öğretmenler ve rehberlik servisi ile iletişim kurmak için bir
                konuşma seçin.
              </p>
              <button onClick={() => setShowNewMessageModal(true)} className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:opacity-90 transition-colors" data-id="element-853">
                {' '}
                {/* LACİVERT */}
                Yeni Mesaj
              </button>
            </div>}
        </div>
      </div>
      {/* Yeni Mesaj Modal */}
      {showNewMessageModal && <VeliNewMessageModal onClose={() => setShowNewMessageModal(false)} onCreateConversation={handleCreateConversation} data-id="element-854" />}
    </div>;
}
export { VeliMessages };